<script>
    import Layout from "../../layouts/main";
    import PageHeader from "@/components/page-header";
    import appConfig from "@/app.config";
    import Orders from "@/services/Orders";
    import modalViewOrder from  '@/components/modals/orders/modalViewOrder';
    import modalEditOrder from  '@/components/modals/orders/modalEditOrder';
    import modalViewTransaction from "@/components/modals/financials/modalViewTransaction";
    import DatePicker from "vue2-datepicker";
    import moment from "moment";

    /**
     * Orders component
     */
    export default {
        components: { Layout, PageHeader, modalViewOrder, modalEditOrder, DatePicker, modalViewTransaction },
        page: {
            title: "Orders",
            meta: [
                {
                    name: "description",
                    content: appConfig.description,
                },
            ],
        },
        data() {
            return {
                title: "Orders",
                items: [
                    {
                        text: "Orders",
                        active: true,
                    },
                ],
                filterInput: {
                    from_date: '',
                    to_date: '',
                    podProduct: false,
                },



                isBusy: false,
                guid: '',
                transactionId: '',
                legacy: '',
                order_type: '',
                showDateInfo: true,
                tableData: [],
                totalRows: 1,
                currentPage: 1,
                perPage: 10,
                pageOptions: [10, 25, 50, 100],
                filter: null,
                filterOn: [],
                selectedOrderType: null,
                orderTypeOptions: [
                  { value: 'all', text: 'All'},
                  { value: 'merchandising', text: 'Merchandising' },
                  { value: 'ewallet', text: 'Ewallet' }
                ],
                quickDatePresets: [
                  { value: 'today', text: 'Today' },
                  { value: 'thisWeek', text: 'Last 7 days' },
                  { value: 'lastMonth', text: 'Last 30 days' }
                ],
                selectedQuickDate: null,
                isInitialLoad: true,
                sortBy: "created_gmt",
                sortDesc: true,
                fields: [
                    {
                        key: "id",
                        label: "Order ID",
                        class:["text-dark","fw-bold"]
                    },
                    {
                        key: "transaction_id",
                        label: "Transaction Id",
                    },
                    {
                        key: "order_types",
                        label: "Order Type",
                    },
                    {
                        key: "customer_id",
                        label: "Customer",
                    },
                    {
                        key: "company_name",
                        label: "Company Name",
                    },
                    {
                        key: "total",
                        label: "Total",
                        sortable: true,
                        class:["text-end"]
                    },
                    {
                        key: "paid",
                        label: "Paid",
                        sortable: true,
                    },
                       {
                        key: "paid_by",
                        label: "Paid by",
                        sortable: true,
                    },
                    {
                        key: "currency",
                        label: "Currency",
                    },
                    {
                        key: "source",
                        label: "Source",
                    },
                    {
                        key: "created_gmt",
                        label: "Date/Time",
                        sortable: true,
                    },
                    {
                        key: "status",
                        label: "Order Status",
                        sortable: true,
                    },
                    "action",
                ],
            };
        },

        middleware: "authentication",
        computed: {
            dynamicDateInfo() {
                if (!this.showDateInfo) return '';
                
                // On initial load, show default text
                if (this.isInitialLoad) {
                    return 'Orders from the last 7 days';
                }
                
                const today = new Date();
                const startDate = this.filterInput.from_date ? new Date(this.filterInput.from_date) : null;
                const endDate = this.filterInput.to_date ? new Date(this.filterInput.to_date) : null;
                
                if (this.selectedQuickDate) {
                    switch(this.selectedQuickDate) {
                        case 'today':
                            return 'Orders from today';
                        case 'thisWeek':
                            return 'Orders from last 7 days';
                        case 'lastMonth':
                            return 'Orders from last 30 days';
                        default:
                            return 'Orders from selected period';
                    }
                }
                
                if (startDate && endDate) {
                    const startStr = startDate.toLocaleDateString('en-GB', { day: '2-digit', month: '2-digit', year: 'numeric' });
                    const endStr = endDate.toLocaleDateString('en-GB', { day: '2-digit', month: '2-digit', year: 'numeric' });
                    
                    if (startStr === endStr) {
                        return `Orders from ${startStr}`;
                    } else {
                        return `Orders from ${startStr} to ${endStr}`;
                    }
                }
                
                return 'Orders from the last 7 days';
            }
        },
        async created() {
            const today = new Date();
            const sevenDaysAgo = new Date();
            sevenDaysAgo.setDate(today.getDate() - 7);
            this.filterInput.from_date = sevenDaysAgo.toISOString().split("T")[0];
            this.filterInput.to_date = today.toISOString().split("T")[0];0
            await this.getOrders()
        },
        methods: {

            async getOrders(){
                try {
                    this.toggleBusy();
                    var filters = this.getFilters()
                    const response = await Orders.getOrders(filters)

                    this.tableData = response.data.data
                    this.totalRows = this.tableData.length
                    this.toggleBusy();
                } catch (error) {
                    this.toggleBusy();
                    this.error = error.response.data.error ? error.response.data.error : "";
                    this.tableData = []
                    this.totalRows =1
                }
            },
            filterByOrderType() {
              this.isInitialLoad = false;
              this.showDateInfo = true;
              this.getOrders();
            },
            
            
            applyQuickDate() {
              if (!this.selectedQuickDate) return;
              
              this.isInitialLoad = false;
              this.showDateInfo = true;
              const today = new Date();
              let startDate, endDate;
              
              switch(this.selectedQuickDate) {
                case 'today':
                  startDate = endDate = today;
                  break;
                case 'thisWeek': {
                  const last7Days = new Date();
                  last7Days.setDate(today.getDate() - 7);
                  startDate = last7Days;
                  endDate = today;
                  break;
                }
                case 'lastMonth': {
                  const last30Days = new Date();
                  last30Days.setDate(today.getDate() - 30);
                  startDate = last30Days;
                  endDate = today;
                  break;
                }
              }
              
              this.filterInput.from_date = startDate.toISOString().split("T")[0];
              this.filterInput.to_date = endDate.toISOString().split("T")[0];
              this.getOrders();
            },
            
            exportOrders() {
              // Create CSV content
              const headers = ['Order ID', 'Transaction ID', 'Order Type', 'Customer', 'Total', 'Status', 'Date'];
              const csvContent = [
                headers.join(','),
                ...this.tableData.map(order => [
                  order.id,
                  order.transaction_id || '',
                  order.order_types || '',
                  `${order.first_name || ''} ${order.last_name || ''}`.trim(),
                  order.total || '0',
                  order.status || '',
                  order.created_gmt || ''
                ].join(','))
              ].join('\n');
              
              // Download CSV
              const blob = new Blob([csvContent], { type: 'text/csv' });
              const url = window.URL.createObjectURL(blob);
              const a = document.createElement('a');
              a.href = url;
              a.download = `orders_${new Date().toISOString().split('T')[0]}.csv`;
              a.click();
              window.URL.revokeObjectURL(url);
            },

           getFilters(){
              var filter_string = '&limit=5000';
              if(this.filterInput.from_date) {
                filter_string += (this.filterInput.from_date) ? '&from_date=' + moment(this.filterInput.from_date).format('YYYY-MM-DD') : "";
              }
              if(this.filterInput.to_date) {
                filter_string += (this.filterInput.to_date) ? '&to_date=' + moment(this.filterInput.to_date).format('YYYY-MM-DD') : "";
              }
             if (this.selectedOrderType && this.selectedOrderType !== 'all') {
               filter_string += `&order_type=${this.selectedOrderType}`;
             }
             if (this.filterInput.podProduct) {
               filter_string += '&pod_product=yes';
             }

              return filter_string = filter_string.substring(1);
            },

            modalViewOrder(data){

                this.$bvModal.show("view_order");
                this.guid = data.guid;
                this.legacy = typeof data.legacy !== 'undefined' ? data.legacy : 0;
                this.order_type = data.order_types;
            },

            modalEditOrder(data){
                this.$bvModal.show("edit_order");
                this.guid = data.guid;
                this.legacy = typeof data.legacy !== 'undefined' ? data.legacy : 0;
                this.order_type = data.order_types;
            },

             modalViewTransaction(data){
                this.$bvModal.show("view_transaction");
                this.transactionId = data.transaction_id;
                this.legacy = typeof data.legacy !== 'undefined' ? data.legacy : 0;
             },

            /**
             * Search the table data with search input
             */
            onFiltered(filteredItems) {
                // Trigger pagination to update the number of buttons/pages due to filtering
                this.totalRows = filteredItems.length;
                this.currentPage = 1;
            },

            hideDateInfo(){
               // Only hide if no quick date is selected and dates are manually changed
               if (!this.selectedQuickDate) {
                 this.isInitialLoad = false;
                 this.showDateInfo = false;
               }
            },
            
            resetFilters() {
              const today = new Date();
              const sevenDaysAgo = new Date();
              sevenDaysAgo.setDate(today.getDate() - 7);
              this.filterInput.from_date = sevenDaysAgo.toISOString().split("T")[0];
              this.filterInput.to_date = today.toISOString().split("T")[0];
              this.selectedOrderType = null;
              this.selectedQuickDate = null;
              this.filterInput.podProduct = false;
              this.isInitialLoad = true;
              this.getOrders();
            }
        },
    };
</script>

<template>
    <Layout>
        <PageHeader :title="title" :items="items" />
        <div class="row">
            <div class="col-12">

               <div class="card">
                      <div class="card-body">

                        <div class="row mt-4">
                          <div class="col-md-12">
                            <div class="custom-accordion">
                              <a
                                  class="text-body fw-semibold pb-2 d-block"
                                  data-toggle="collapse"
                                  href="javascript: void(0);"
                                  role="button"
                                  aria-expanded="false"
                                  v-b-toggle.categories-collapse
                              >
                                <i class="mdi mdi-chevron-up accor-down-icon text-primary me-1"></i>Filters
                              </a>
                              <b-collapse visible id="categories-collapse">
                                <div class="card shadow-none">
                                    <div class="row">
                                     
                                      
                                      <!-- Start Date -->
                                      <div class="col-sm-12 col-md-3">
                                        <b-form-group label="Start Date" label-for="formrow-from_date-input" class="mb-3">
                                          <date-picker
                                                  v-model="filterInput.from_date"
                                                  append-to-body
                                                  lang="en"
                                                  confirm
                                                  format="DD-MM-YYYY"
                                                  @input="hideDateInfo"
                                          ></date-picker>
                                        </b-form-group>
                                      </div>
                                      
                                      <!-- End Date -->
                                      <div class="col-sm-12 col-md-3">
                                        <b-form-group label="End Date" label-for="formrow-to_date-input" class="mb-3">
                                          <date-picker
                                                  v-model="filterInput.to_date"
                                                  append-to-body
                                                  lang="en"
                                                  confirm
                                                  format="DD-MM-YYYY"
                                                  @input="hideDateInfo"
                                          ></date-picker>
                                        </b-form-group>
                                      </div>
                                      
                                      <!-- Order Type -->
                                      <div class="col-sm-12 col-md-3">
                                        <b-form-group label="Order Type" class="mb-3">
                                          <select v-model="selectedOrderType" class="form-select" @change="filterByOrderType">
                                            <option v-for="option in orderTypeOptions" :key="option.value" :value="option.value">
                                              {{ option.text }}
                                            </option>
                                          </select>
                                        </b-form-group>
                                      </div>
                                       <!-- POD Products Checkbox -->
                                       <div class="col-sm-12 col-md-3">
                                        <b-form-group label="POD Products" class="mb-3">
                                          <div class="form-check">
                                            <input
                                                v-model="filterInput.podProduct"
                                                class="form-check-input"
                                                type="checkbox"
                                                id="podProductCheck"
                                            >
                                            <label class="form-check-label" for="podProductCheck">
                                              <i class="mdi mdi-package-variant me-1"></i>Show POD Products
                                            </label>
                                          </div>
                                        </b-form-group>
                                      </div>
                                    </div>
                                    
                                    <div class="row">
                                     
                                       <!-- Quick Date Presets -->
                                       <div class="col-sm-12 col-md-3">
                                        <b-form-group label="Quick Date" class="mb-3">
                                          <select v-model="selectedQuickDate" class="form-select" @change="applyQuickDate">
                                            <option value="">Select preset...</option>
                                            <option v-for="preset in quickDatePresets" :key="preset.value" :value="preset.value">
                                              {{ preset.text }}
                                            </option>
                                          </select>
                                        </b-form-group>
                                      </div>
                                      <!-- Empty space for alignment -->
                                      <div class="col-sm-12 col-md-9"></div>
                                    </div>
                                  <div class="row">
                                    <div class="col d-inline-flex gap-2">
                                      <button type="button" class="btn btn-success" @click="getOrders">
                                        <i class="mdi mdi-filter me-1"></i>Filter
                                      </button>
                                      <button type="button" class="btn btn-outline-primary" @click="resetFilters">
                                        <i class="mdi mdi-refresh me-1"></i>Reset
                                      </button>
                                      <button type="button" class="btn btn-outline-success" @click="exportOrders" :disabled="tableData.length === 0">
                                        <i class="mdi mdi-download me-1"></i>Export CSV
                                      </button>
                                    </div>

                                     <p id="date_info" class="text-muted mt-3 mb-0 text-left" v-if="showDateInfo">
                                        <i class="mdi mdi-calendar-range me-1"></i>
                                        <span>{{ dynamicDateInfo }}</span>
                                     </p>
                                  </div>

                                </div>
                              </b-collapse>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>


                <div class="table table-centered datatable dt-responsive nowrap table-card-list dataTable no-footer dtr-inline">
                    <div class="row">
                        <div class="col-sm-12 col-md-6">
                            <div id="tickets-table_length" class="dataTables_length">
                                <label class="d-inline-flex align-items-center fw-normal">
                                    Show&nbsp;
                                    <b-form-select
                                            v-model="perPage"
                                            size="sm"
                                            :options="pageOptions"
                                    ></b-form-select
                                    >&nbsp;entries
                                </label>
                            </div>
                        </div>
                        <!-- Search -->
                        <div class="col-sm-12 col-md-6">
                            <div
                                    id="tickets-table_filter"
                                    class="dataTables_filter text-md-end"
                            >
                                <label class="d-inline-flex align-items-center fw-normal">
                                    Search:
                                    <b-form-input
                                            v-model="filter"
                                            type="search"
                                            placeholder="Search..."
                                            class="form-control form-control-sm ms-2"
                                    ></b-form-input>
                                </label>
                            </div>
                        </div>
                        <!-- End search -->
                    </div>
                    <!-- Table -->

                    <b-table
                            table-class="table-responsive mb-0"
                            :busy="isBusy"
                            :items="tableData"
                            :fields="fields"
                            responsive="sm"
                            :per-page="perPage"
                            :current-page="currentPage"
                            :sort-by.sync="sortBy"
                            :sort-desc.sync="sortDesc"
                            :filter="filter"
                            :filter-included-fields="filterOn"
                            sort-icon-left
                            @filtered="onFiltered"
                            show-empty
                            empty-text="No orders found for the selected criteria"
                    >
                        <template #table-busy>
                            <div class="text-center text-danger my-2">
                                <b-spinner class="align-middle"></b-spinner>
                                <strong>Loading...</strong>
                            </div>
                        </template>
                        
                        <template #empty>
                            <div class="text-center py-4">
                                <i class="mdi mdi-package-variant-closed font-size-48 text-muted"></i>
                                <h5 class="mt-2">No Orders Found</h5>
                                <p class="text-muted">No orders found for the selected criteria. Try adjusting your filters.</p>
                            </div>
                        </template>

                       <template v-slot:cell(transaction_id)="data">

                              <a
                                  href="javascript:void(0);"
                                  @click="modalViewTransaction(data.item)"
                                  class="px-2 text-primary"
                                  v-b-tooltip.hover
                                  title="View Transaction Details"
                              >
                                {{data.item.transaction_id}}
                              </a>

                        </template>

                         <template v-slot:cell(total)="data">
                            <span class="fw-bold text-success">€{{parseFloat(data.item.total).toFixed(2)}}</span>
                          </template>

                        <template v-slot:cell(customer_id)="data">
                            <router-link :to="{ path: `/customers/profile/${data.item.customer_id}`}">
                                <span v-if="data.item.first_name || data.item.last_name">{{ data.item.first_name + ' ' +  data.item.last_name }}</span>
                            </router-link>
                        </template>

                        <!--<template v-slot:cell(status)="data">
                            <div
                                    class="badge bg-pill bg-soft-success font-size-12 text-capitalize"
                                    :class="{
                                      'bg-soft-danger': data.item.status === 'cancelled',
                                      'bg-soft-warning': data.item.status === 'processing',
                                      'bg-soft-danger': data.item.status === 'failed',
                                    }"
                            >
                                {{ data.item.status }}
                            </div>
                        </template> -->

                         <template v-slot:cell(status)="data">
                              <span 
                                class="badge font-size-12"
                                :class="{
                                  'bg-success': data.item.status === 'completed',
                                  'bg-warning': data.item.status === 'processing',
                                  'bg-danger': data.item.status === 'cancelled' || data.item.status === 'failed',
                                  'bg-secondary': !['completed', 'processing', 'cancelled', 'failed'].includes(data.item.status)
                                }"
                              >
                                {{ data.item.status || 'Unknown' }}
                              </span>
                        </template>

                        <template v-slot:cell(action)="data">
                            <ul class="list-inline mb-0">
                                <li class="list-inline-item">
                                    <a
                                            href="javascript:void(0);"
                                            @click="modalViewOrder(data.item)"
                                            class="px-2 text-primary"
                                            v-b-tooltip.hover
                                            title="View Order"
                                    >
                                        <i class="uil uil-eye font-size-18"></i>
                                    </a>
                                </li>
                                <li class="list-inline-item">
                                    <a
                                            href="javascript:void(0);"
                                            @click="modalEditOrder(data.item)"
                                            class="px-2 text-primary"
                                            v-b-tooltip.hover
                                            title="Edit Order"
                                    >
                                        <i class="uil uil-pen font-size-18"></i>
                                    </a>
                                </li>
                            </ul>
                        </template>
                    </b-table>
                </div>
                <div class="row">
                    <div class="col">
                        <div class="dataTables_paginate paging_simple_numbers float-end">
                            <ul class="pagination pagination-rounded">
                                <!-- pagination -->
                                <b-pagination
                                        v-model="currentPage"
                                        :total-rows="totalRows"
                                        :per-page="perPage"
                                ></b-pagination>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- MODALS -->
        <modalViewOrder :guid="this.guid" :legacy="this.legacy" :order_type="this.order_type"></modalViewOrder>
        <modalEditOrder :guid="this.guid" :legacy="this.legacy" :order_type="this.order_type"  @onRefresh="getOrders()"></modalEditOrder>
        <modalViewTransaction :transactionId="transactionId" :legacy="this.legacy" @onRefresh="getOrders()" ></modalViewTransaction>
        <!-- /MODALS -->

    </Layout>
</template>
